// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `iframe#webpack-dev-server-client-overlay {
  display: none; }

.outer-dashboard-container {
  position: relative;
  border-top: 1px solid #ffffff24;
  height: calc(100vh - 80px);
  margin-right: 0px;
  padding-right: 0px;
  margin-top: 70px;
  padding-left: 0px; }
  .outer-dashboard-container .form-floating > .form-control:focus ~ label, .outer-dashboard-container .form-floating > .form-control:not(:placeholder-shown) ~ label, .outer-dashboard-container .form-floating > .form-control-plaintext ~ label, .outer-dashboard-container .form-floating > .form-select ~ label {
    color: white;
    opacity: 0.65;
    transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem); }
  .outer-dashboard-container .form-floating > .form-control:focus ~ label::after, .outer-dashboard-container .form-floating > .form-control:not(:placeholder-shown) ~ label::after, .outer-dashboard-container .form-floating > .form-control-plaintext ~ label::after, .outer-dashboard-container .form-floating > .form-select ~ label::after {
    background-color: unset; }
  .outer-dashboard-container .sidebar-left {
    background-color: #011b3a;
    display: flex;
    justify-content: flex-start;
    height: calc(100% - 45px);
    width: 205px;
    position: absolute;
    padding-left: 5px; }
    .outer-dashboard-container .sidebar-left .sidebar-list {
      list-style: none;
      color: white;
      font-size: 16px;
      font-weight: 500;
      font-family: Urbanist;
      margin-top: 3rem;
      padding-left: 0;
      white-space: nowrap; }
    .outer-dashboard-container .sidebar-left .sidebar-item {
      padding: 8px;
      padding-left: 1px;
      padding-right: 1px;
      padding-top: 11px;
      padding-bottom: 11px;
      font-size: 18px; }
    .outer-dashboard-container .sidebar-left .sidebar-item:hover {
      color: #4fc2d9;
      cursor: pointer; }
    .outer-dashboard-container .sidebar-left .sidebar-item-active {
      color: #4fc2d9;
      width: 100%;
      border-radius: 6px 0 0 6px;
      background-image: linear-gradient(to right, #4fc2d929, #011b3a); }
    .outer-dashboard-container .sidebar-left .list-icon {
      width: 42px; }
  .outer-dashboard-container .sidebar-left-sm {
    width: 110px; }
    .outer-dashboard-container .sidebar-left-sm .sidebar-item {
      padding: 8px;
      padding-left: 1px;
      padding-right: 1px;
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 12px; }
      .outer-dashboard-container .sidebar-left-sm .sidebar-item span {
        max-width: 80px;
        text-align: center; }
      .outer-dashboard-container .sidebar-left-sm .sidebar-item svg {
        height: 30px; }
  .outer-dashboard-container .insight-navbar-o {
    background-color: #0a1634; }
  .outer-dashboard-container .insight-navbar {
    display: flex;
    align-items: center;
    color: white;
    font-weight: bold;
    height: 57px;
    justify-content: space-between;
    width: 100%;
    z-index: 9;
    text-align: center;
    position: absolute;
    background-color: #011b3a; }
    .outer-dashboard-container .insight-navbar .navbar-list {
      display: inline-flex;
      list-style: none;
      margin-top: 1rem;
      padding-left: 10;
      font-weight: normal;
      align-items: center; }
      .outer-dashboard-container .insight-navbar .navbar-list .active {
        border-bottom: 4px solid #07bc0c;
        color: #4fc2d9; }
      .outer-dashboard-container .insight-navbar .navbar-list .navbar-item {
        padding: 1rem; }
        .outer-dashboard-container .insight-navbar .navbar-list .navbar-item:hover {
          color: #4fc2d9;
          cursor: pointer; }
    .outer-dashboard-container .insight-navbar .wm-org-title-bar-form {
      flex-direction: row;
      display: inline-flex;
      align-items: center;
      justify-content: end; }
      .outer-dashboard-container .insight-navbar .wm-org-title-bar-form .wm-organizations-select {
        margin-left: 10px;
        margin-right: 20px; }
      .outer-dashboard-container .insight-navbar .wm-org-title-bar-form .form-label {
        font-weight: normal;
        margin-bottom: 0px; }
      .outer-dashboard-container .insight-navbar .wm-org-title-bar-form textarea {
        color: white; }
  @media only screen and (max-width: 800px) {
    .outer-dashboard-container .wm-org-title-bar {
      right: 0px;
      position: absolute;
      top: 50px; }
    .outer-dashboard-container .insight-navbar .navbar-list {
      padding-left: 5px; }
      .outer-dashboard-container .insight-navbar .navbar-list .navbar-item {
        padding: .5rem; } }
  .outer-dashboard-container .inner-dashboard-container {
    position: absolute;
    top: 80px;
    left: 230px;
    color: white;
    width: calc(100% - 250px);
    height: calc(100vh - 170px); }
    .outer-dashboard-container .inner-dashboard-container h2 {
      color: white;
      font-weight: bold;
      margin-left: 10px; }
    .outer-dashboard-container .inner-dashboard-container .accordion-collapse {
      color: white !important; }
    .outer-dashboard-container .inner-dashboard-container .organization-info .table-container {
      max-height: calc(100vh - 250px);
      overflow: auto; }
    .outer-dashboard-container .inner-dashboard-container .admin-settings-table .table-container {
      max-height: calc(100vh - 280px);
      overflow: auto; }
    .outer-dashboard-container .inner-dashboard-container #organization-dashboard-container {
      margin-left: -220px;
      margin-top: 10px;
      width: 97.5vw; }
    .outer-dashboard-container .inner-dashboard-container #organization-dashboard-container-bottom {
      width: 96vw;
      margin-left: -219px;
      max-width: unset;
      padding-bottom: 20px; }
    .outer-dashboard-container .inner-dashboard-container #referencedata-container {
      margin-left: -200px;
      margin-top: 10px;
      width: 95vw; }
      .outer-dashboard-container .inner-dashboard-container #referencedata-container .spinner-overlay {
        margin-left: -200px;
        margin-top: 200px;
        width: 965vw;
        background: rgba(29, 32, 30, 0.54); }
    .outer-dashboard-container .inner-dashboard-container #help-container {
      margin-left: -200px;
      margin-top: 20px;
      width: 95vw;
      min-width: -webkit-fill-available; }
    .outer-dashboard-container .inner-dashboard-container .table-scroll {
      margin-top: 10px; }
      .outer-dashboard-container .inner-dashboard-container .table-scroll table {
        max-height: 90vh !important;
        overflow: auto auto;
        height: calc(100vh - 340px);
        display: inline-block; }
    .outer-dashboard-container .inner-dashboard-container .metrics-container {
      background-color: #0b1736;
      border-radius: 7px;
      padding: 1rem;
      margin-right: 1px;
      margin: 1rem;
      min-width: 200px; }
      .outer-dashboard-container .inner-dashboard-container .metrics-container .organization-totals {
        display: flex;
        justify-content: center;
        align-items: center; }
        .outer-dashboard-container .inner-dashboard-container .metrics-container .organization-totals h5 {
          font-size: 14px;
          margin-bottom: 0; }
        .outer-dashboard-container .inner-dashboard-container .metrics-container .organization-totals .number-of-organizations {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 50px;
          height: 50px;
          background-color: #021d3e;
          border-radius: 8px;
          margin-left: 4px; }
          .outer-dashboard-container .inner-dashboard-container .metrics-container .organization-totals .number-of-organizations h2 {
            color: #4fc2d9;
            margin-bottom: 0; }
      .outer-dashboard-container .inner-dashboard-container .metrics-container .metrics-container-top .metric-headings h5,
      .outer-dashboard-container .inner-dashboard-container .metrics-container .metrics-container-top .metric-headings p,
      .outer-dashboard-container .inner-dashboard-container .metrics-container .metrics-container-top .admin-task-top h5,
      .outer-dashboard-container .inner-dashboard-container .metrics-container .metrics-container-top .admin-task-top p {
        font-weight: bold; }
      .outer-dashboard-container .inner-dashboard-container .metrics-container .metrics-container-top .metric-headings p,
      .outer-dashboard-container .inner-dashboard-container .metrics-container .metrics-container-top .admin-task-top p {
        margin-top: 1rem;
        font-weight: normal; }
      .outer-dashboard-container .inner-dashboard-container .metrics-container .metric-container {
        background-color: #021d3e;
        margin: 9px;
        padding: 8px;
        border-radius: 8px; }
        .outer-dashboard-container .inner-dashboard-container .metrics-container .metric-container .metric {
          color: #4fc2d9; }
        .outer-dashboard-container .inner-dashboard-container .metrics-container .metric-container .metric-title {
          font-size: 12px; }
        .outer-dashboard-container .inner-dashboard-container .metrics-container .metric-container p {
          font-weight: normal; }
  .outer-dashboard-container .admin-task-container {
    background-color: #0b1736;
    border-radius: 8px;
    padding: 1rem;
    margin: 1rem;
    min-width: 200px; }
    .outer-dashboard-container .admin-task-container .admin-task-top {
      font-weight: bold; }
      .outer-dashboard-container .admin-task-container .admin-task-top h5,
      .outer-dashboard-container .admin-task-container .admin-task-top p {
        font-weight: bold; }
      .outer-dashboard-container .admin-task-container .admin-task-top p {
        font-weight: normal; }
    .outer-dashboard-container .admin-task-container .admin-task-bottom .table-container {
      overflow: auto; }
    .outer-dashboard-container .admin-task-container .admin-task-header {
      color: white;
      font-weight: normal; }
  .outer-dashboard-container .form-check-input {
    border-color: #86b7fe;
    outline: 0;
    box-shadow: 0 0 0 0.25rem  #0D6EFD; }
  .outer-dashboard-container tr:nth-child(2) .form-check-input:checked {
    background-color: #0d6efd; }
  .outer-dashboard-container tr:nth-child(3) .form-check-input:checked {
    background-color: #0d6efd; }
  .outer-dashboard-container tr:nth-child(4) .form-check-input:checked {
    background-color: #0d6efd; }
  .outer-dashboard-container tr:nth-child(5) .form-check-input:checked {
    background-color: #0d6efd; }
  .outer-dashboard-container tr:nth-child(6) .form-check-input:checked {
    background-color: #0d6efd; }
  .outer-dashboard-container .header-container {
    padding-right: 0px; }
  .outer-dashboard-container .header-options-container {
    justify-content: flex-end;
    padding-right: 0px; }
  .outer-dashboard-container .dropdown-dashboard {
    margin-left: 0px !important; }
  .outer-dashboard-container .dropdown-more-options-container button {
    padding-right: 0px;
    margin-left: 10px; }
  .outer-dashboard-container .action {
    display: flex;
    justify-content: space-between; }
  .outer-dashboard-container .vertical-seperator {
    border-right: 2px solid #222d48; }
  .outer-dashboard-container .getting-started-container {
    position: absolute;
    left: 1%;
    right: 1%;
    padding: 1rem;
    border-radius: 8px;
    background-color: #0b1736; }
    .outer-dashboard-container .getting-started-container h5 {
      font-weight: bold; }
    .outer-dashboard-container .getting-started-container .accordion-button {
      background-color: #0b1736; }
    .outer-dashboard-container .getting-started-container .accordion-button:not(.collapsed) {
      color: #4fc2d9;
      font-weight: bold; }
    .outer-dashboard-container .getting-started-container .accordion-item {
      border: none;
      border-bottom: 1px solid #222d48; }
  .outer-dashboard-container table {
    border-radius: 4px;
    color: white; }
    .outer-dashboard-container table td {
      border: 1px solid #2a2a2a; }
    .outer-dashboard-container table thead th:nth-child(1) {
      width: 5%; }
    .outer-dashboard-container table thead th:nth-child(2) {
      width: 20%; }
    .outer-dashboard-container table thead th:nth-child(3) {
      width: 70%; }
    .outer-dashboard-container table input {
      background-color: transparent;
      border: none;
      color: white; }
    .outer-dashboard-container table .icon-box {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 10%;
      color: #4fc2d9; }
    .outer-dashboard-container table .form-input-wrapper input {
      background-color: transparent;
      border: none;
      color: white; }
  .outer-dashboard-container .header-box {
    display: flex;
    align-items: center;
    justify-content: space-between; }
    .outer-dashboard-container .header-box #export-btn {
      color: white;
      font-weight: bold;
      background-color: transparent;
      border: 1px solid #4fc2d9 !important; }
      .outer-dashboard-container .header-box #export-btn:hover {
        color: #4fc2d9; }
    .outer-dashboard-container .header-box #addNew-btn {
      color: white;
      font-weight: bold; }
  .outer-dashboard-container .action-cell {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%; }
  .outer-dashboard-container .reference-data {
    justify-content: space-around; }
  .outer-dashboard-container .org-edit-form .form-control {
    background-color: #021d3e;
    border: none;
    color: white; }
  .outer-dashboard-container .org-edit-form .org-warning-box {
    display: flex;
    justify-content: space-around;
    align-items: center;
    color: #ff6666;
    border: 1px solid #ff6666;
    border-radius: 4px;
    width: 40%;
    height: 3rem;
    font-size: 13px; }
    .outer-dashboard-container .org-edit-form .org-warning-box p {
      margin-bottom: 0;
      margin-left: 20px; }
  .outer-dashboard-container .org-edit-form .cred-box {
    background-color: #0b1736;
    margin-left: 1%;
    width: 98%;
    border-radius: 6px; }
  .outer-dashboard-container .user-box {
    background-color: #0b1736;
    margin-left: 1%;
    border-radius: 6px; }
    .outer-dashboard-container .user-box h4 {
      padding-top: 1rem; }
    .outer-dashboard-container .user-box .user-list {
      list-style: none;
      background-color: #021d3e;
      height: 8rem;
      padding: 1rem;
      border-radius: 6px;
      overflow: auto; }
    .outer-dashboard-container .user-box .list-group {
      height: 38vh;
      overflow-y: scroll; }
      .outer-dashboard-container .user-box .list-group .list-group-item {
        color: white;
        background-color: #002044; }
        .outer-dashboard-container .user-box .list-group .list-group-item.active {
          background-color: #4fc2d9; }
    .outer-dashboard-container .user-box .user-list-control-container {
      display: flex;
      flex-direction: row;
      height: 30px; }
      .outer-dashboard-container .user-box .user-list-control-container .user-list-control-container {
        display: flex;
        flex-direction: row; }
      .outer-dashboard-container .user-box .user-list-control-container div {
        margin-right: 10px; }
  .outer-dashboard-container .footer-button-box {
    display: flex;
    justify-content: flex-end; }
  .outer-dashboard-container .project {
    justify-content: flex-start; }
  .outer-dashboard-container #footer-btn {
    width: 9rem;
    font-size: 14px; }
  .outer-dashboard-container .edit-btn {
    background-color: #4fc2d9; }
    .outer-dashboard-container .edit-btn:hover {
      background-color: #4da1d8;
      transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  .outer-dashboard-container .cancel-btn {
    color: white;
    font-weight: bold;
    background-color: transparent;
    border: 1px solid #4fc2d9 !important; }
    .outer-dashboard-container .cancel-btn:hover {
      color: #4fc2d9; }
  .outer-dashboard-container .monitoring-location-container .table-container {
    max-width: calc(100% - 30px);
    overflow: auto; }
  .outer-dashboard-container .monitoring-location-container tbody {
    background-color: #0b1736; }
  .outer-dashboard-container .monitoring-location-container .table-container {
    max-height: calc(90vh - 200px); }
  .outer-dashboard-container .monitoring-location-container .action-box {
    display: flex;
    justify-content: space-around; }
    .outer-dashboard-container .monitoring-location-container .action-box input {
      border-color: #86b7fe;
      outline: 0;
      box-shadow: 0 0 0 0.25rem RGB(13 110 253/25%); }
  .outer-dashboard-container .edit {
    text-align: end; }
  .outer-dashboard-container #export-btn {
    color: white;
    font-weight: bold;
    background-color: transparent;
    border: 1px solid #4fc2d9 !important; }
    .outer-dashboard-container #export-btn:hover {
      color: #4fc2d9; }
  .outer-dashboard-container select, .outer-dashboard-container textarea {
    background-color: #051D3E;
    border: none;
    color: #ffffff5c; }
  .outer-dashboard-container #filter-box {
    margin-bottom: 1rem;
    position: relative;
    left: 1%; }
  .outer-dashboard-container .filter-box,
  .outer-dashboard-container .add-activity-box {
    display: flex;
    justify-content: space-between;
    padding-right: 0px;
    margin-right: 0px;
    margin: 0;
    padding-left: 0;
    background-color: #0b1736;
    margin-bottom: 1rem;
    margin: 0;
    padding: 1rem;
    border-radius: 4px; }
    .outer-dashboard-container .filter-box .drop-box,
    .outer-dashboard-container .add-activity-box .drop-box {
      display: flex;
      align-items: center; }
      .outer-dashboard-container .filter-box .drop-box select,
      .outer-dashboard-container .add-activity-box .drop-box select {
        background-color: #021d3e;
        color: #ffffff82;
        border: none; }
      .outer-dashboard-container .filter-box .drop-box h4,
      .outer-dashboard-container .add-activity-box .drop-box h4 {
        margin-bottom: 0;
        margin-right: 4px; }
    .outer-dashboard-container .filter-box #importII,
    .outer-dashboard-container .add-activity-box #importII {
      width: 35vw; }
    .outer-dashboard-container .filter-box .date-range-box,
    .outer-dashboard-container .add-activity-box .date-range-box {
      display: flex;
      justify-content: center;
      align-items: center; }
      .outer-dashboard-container .filter-box .date-range-box .date-box,
      .outer-dashboard-container .add-activity-box .date-range-box .date-box {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0.5rem;
        background-color: #021d3e;
        border-radius: 8px;
        margin: 4px;
        z-index: 11 !important; }
        .outer-dashboard-container .filter-box .date-range-box .date-box input,
        .outer-dashboard-container .add-activity-box .date-range-box .date-box input {
          width: 7rem;
          background-color: transparent;
          border: none;
          color: #ffffff82; }
        .outer-dashboard-container .filter-box .date-range-box .date-box p,
        .outer-dashboard-container .add-activity-box .date-range-box .date-box p {
          width: 4rem;
          margin-bottom: 0;
          font-weight: bold;
          color: #ffffff82; }
        .outer-dashboard-container .filter-box .date-range-box .date-box #to,
        .outer-dashboard-container .add-activity-box .date-range-box .date-box #to {
          margin-right: -1rem; }
          .outer-dashboard-container .filter-box .date-range-box .date-box #to input,
          .outer-dashboard-container .add-activity-box .date-range-box .date-box #to input {
            margin-left: -2px; }
        .outer-dashboard-container .filter-box .date-range-box .date-box #from,
        .outer-dashboard-container .add-activity-box .date-range-box .date-box #from {
          width: 5rem; }
          .outer-dashboard-container .filter-box .date-range-box .date-box #from input,
          .outer-dashboard-container .add-activity-box .date-range-box .date-box #from input {
            margin-left: -5px; }
        .outer-dashboard-container .filter-box .date-range-box .date-box .react-datepicker-wrapper,
        .outer-dashboard-container .add-activity-box .date-range-box .date-box .react-datepicker-wrapper {
          width: 70%; }
  .outer-dashboard-container .add-activity-box {
    width: 100% !important; }
    .outer-dashboard-container .add-activity-box form {
      width: 100%; }
      .outer-dashboard-container .add-activity-box form input[type="text"] {
        background-color: #021d3e;
        border: none;
        color: #fff !important; }
    .outer-dashboard-container .add-activity-box .add-activities-button-box {
      display: flex;
      justify-content: flex-end; }
      .outer-dashboard-container .add-activity-box .add-activities-button-box #export-btn {
        color: white;
        font-weight: bold;
        background-color: transparent;
        border: 1px solid #4fc2d9 !important; }
        .outer-dashboard-container .add-activity-box .add-activities-button-box #export-btn:hover {
          color: #4fc2d9; }
  .outer-dashboard-container .results-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center; }
    .outer-dashboard-container .results-wrapper #export-btn {
      color: white;
      font-weight: bold;
      background-color: transparent;
      border: 1px solid #4fc2d9 !important; }
      .outer-dashboard-container .results-wrapper #export-btn:hover {
        color: #4fc2d9; }

.outer-dashboard-container-sm {
  width: 100vw;
  margin-top: 70px; }
  .outer-dashboard-container-sm .sidebar-left {
    width: 110px; }
    .outer-dashboard-container-sm .sidebar-left .sidebar-list {
      white-space: pre-wrap; }
    .outer-dashboard-container-sm .sidebar-left .sidebar-item {
      padding: 8px;
      padding-left: 1px;
      padding-right: 1px;
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 12px;
      text-align: center;
      margin-bottom: 15px; }
      .outer-dashboard-container-sm .sidebar-left .sidebar-item span {
        max-width: 80px;
        margin-top: 2px;
        text-align: center; }
      .outer-dashboard-container-sm .sidebar-left .sidebar-item svg {
        height: 30px; }
  .outer-dashboard-container-sm .inner-dashboard-container {
    top: 80px;
    left: 120px !important;
    width: calc(100% - 110px); }
    .outer-dashboard-container-sm .inner-dashboard-container .fullscreen-watermonitoringreport {
      margin-left: -110px;
      width: 100vw; }
    .outer-dashboard-container-sm .inner-dashboard-container .organization-info .table-container {
      max-height: calc(100vh - 250px);
      overflow: auto; }
    .outer-dashboard-container-sm .inner-dashboard-container #organization-dashboard-container {
      margin-left: -90px; }
    .outer-dashboard-container-sm .inner-dashboard-container #organization-dashboard-container-bottom {
      margin-left: -90px; }
    .outer-dashboard-container-sm .inner-dashboard-container #referencedata-container {
      margin-left: -90px; }
    .outer-dashboard-container-sm .inner-dashboard-container #help-container {
      margin-left: -80px; }
    .outer-dashboard-container-sm .inner-dashboard-container .admin-container {
      width: 90vw; }

.wm-table-overflow {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical; }

.bulk-import {
  flex-direction: column; }
  .bulk-import h3 {
    font-size: 18px;
    margin-bottom: -8px;
    font-weight: bold; }
  .bulk-import textarea {
    background-color: #041b3c;
    border: none;
    color: white; }

.bottom-half {
  display: flex;
  justify-content: space-between; }

.import-details {
  flex-direction: column; }

.danger-box {
  border: 1px solid #ff6666;
  padding: 4px;
  border-radius: 4px; }
  .danger-box .warning-icon {
    border: 2px solid #ff6666;
    border-radius: 50%;
    padding-right: 8px;
    padding-left: 7px;
    font-weight: bold; }
  .danger-box span {
    margin-left: 12px;
    color: #ff6666; }

.edit-roll {
  width: 96%; }

.active-input {
  background-color: #021d3e;
  border-radius: 4px; }

.reference-data-table-container table thead th:nth-child(1) {
  width: 20%; }

.reference-data-table-container table thead th:nth-child(2) {
  width: 50%; }

.reference-data-table-container table thead th:nth-child(3) {
  width: 5%; }

.reference-data-table-container table thead th:nth-child(4) {
  width: 20%; }

.reference-data-table-container table thead th:nth-child(5) {
  width: 5%; }

.wm-org-cred {
  flex-direction: row;
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: auto; }
  .wm-org-cred button {
    align-self: flex-end; }

.wm-org-display-none {
  display: none; }

.wm-indent {
  padding: 2px 12px; }

.wm-org-cred-check {
  margin-left: 14px;
  width: 30px;
  display: inline-flex;
  vertical-align: top; }

.wm-reference-select {
  color: white !important; }

.modal-container {
  position: absolute;
  z-index: 500;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.486);
  display: flex;
  justify-content: center;
  align-items: center; }
  .modal-container .modal-wrapper {
    width: 40%;
    height: 30%;
    background-color: #0a1634;
    position: absolute;
    top: 20%;
    border-radius: 4px; }
    .modal-container .modal-wrapper .modal {
      position: absolute;
      display: block;
      color: white; }
      .modal-container .modal-wrapper .modal .modal-header {
        width: 100%;
        background-color: #0a1634;
        height: 5%; }
        .modal-container .modal-wrapper .modal .modal-header p {
          margin-bottom: 0; }
      .modal-container .modal-wrapper .modal .modal-body {
        width: 100%;
        height: calc(100% - 100px);
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        overflow-y: auto; }
        .modal-container .modal-wrapper .modal .modal-body .form-check {
          margin-right: 6px;
          width: 100%; }
      .modal-container .modal-wrapper .modal .modal-footer {
        width: 100%;
        background-color: #0a1634;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center; }
        .modal-container .modal-wrapper .modal .modal-footer .modal-button-container {
          margin-top: 5px; }
          .modal-container .modal-wrapper .modal .modal-footer .modal-button-container button {
            margin-right: 14px; }
  .modal-container .add-char-wrapper {
    top: 5vh;
    height: 80vh;
    max-height: 700px; }
    .modal-container .add-char-wrapper .col-4 {
      align-self: center; }
    .modal-container .add-char-wrapper .col-8 input {
      margin: 4px; }
    .modal-container .add-char-wrapper .col-8 .label {
      vertical-align: sub; }
  .modal-container .add-char-modal-footer {
    height: 10% !important;
    position: absolute;
    bottom: 0; }
  .modal-container .translation-modal-wrapper {
    height: 25% !important; }
  .modal-container .translation-modal-footer {
    height: 20% !important; }

.double-btn-box {
  display: flex; }
  .double-btn-box button {
    margin: 4px; }

.gir-container {
  width: 80vw;
  position: relative; }
  .gir-container .gir-tabs-container {
    position: absolute;
    width: 100%; }
  .gir-container .info-box {
    border: 1px dashed #3e982e;
    text-align: center;
    border-radius: 4px;
    background-color: #3e982e3d;
    position: relative; }
    .gir-container .info-box p {
      color: #3e982e;
      margin: 0;
      padding: 4px;
      font-size: 14px; }
  .gir-container .characteristic {
    text-align: left; }

.add-activity-box select {
  color: white; }

.add-activity-box textarea {
  color: white; }

.wm-popover {
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.2); }

.wm-popover-header {
  background-color: #12234f;
  color: white; }

.wqx-container-modal .modal-dialog {
  max-width: 70vw; }
  .wqx-container-modal .modal-dialog .modal-body {
    max-height: 70vh;
    overflow: auto; }
`, "",{"version":3,"sources":["webpack://./src/features/reports/WaterMonitoring/water-monitoring.scss"],"names":[],"mappings":"AAAA;EAA2C,aAAa,EAAA;;AAExD;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAA;EAPnB;IAUM,YAAY;IACZ,aAAa;IACb,8DAA8D,EAAA;EAZpE;IAgBM,uBAAuB,EAAA;EAhB7B;IAoBI,yBAAyB;IACzB,aAAa;IACb,2BAA2B;IAC3B,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB,EAAA;IA1BrB;MA6BM,gBAAgB;MAChB,YAAY;MACZ,eAAe;MACf,gBAAgB;MAChB,qBAAqB;MACrB,gBAAgB;MAChB,eAAe;MACf,mBAAmB,EAAA;IApCzB;MAwCM,YAAY;MACZ,iBAAiB;MACjB,kBAAkB;MAClB,iBAAiB;MACjB,oBAAoB;MACpB,eAAe,EAAA;IA7CrB;MAkDQ,cAAc;MACd,eAAe,EAAA;IAnDvB;MAwDM,cAAc;MACd,WAAW;MACX,0BAA0B;MAC1B,+DAA+D,EAAA;IA3DrE;MA+DM,WAAW,EAAA;EA/DjB;IAqEI,YAAY,EAAA;IArEhB;MAwEM,YAAY;MACZ,iBAAiB;MACjB,kBAAkB;MAClB,aAAa;MACb,sBAAsB;MACtB,mBAAmB;MACnB,eAAe,EAAA;MA9ErB;QAiFQ,eAAe;QACf,kBAAkB,EAAA;MAlF1B;QAsFQ,YAAY,EAAA;EAtFpB;IA4FI,yBAAyB,EAAA;EA5F7B;IAgGI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,8BAA8B;IAC9B,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB,EAAA;IA1G7B;MA6GM,oBAAoB;MACpB,gBAAgB;MAChB,gBAAgB;MAChB,gBAAgB;MAChB,mBAAmB;MACnB,mBAAmB,EAAA;MAlHzB;QAqHQ,gCAAgC;QAChC,cAAc,EAAA;MAtHtB;QA0HQ,aAAa,EAAA;QA1HrB;UA4HU,cAAc;UACd,eAAe,EAAA;IA7HzB;MAmIM,mBAAmB;MACnB,oBAAoB;MACpB,mBAAmB;MACnB,oBAAoB,EAAA;MAtI1B;QAyIQ,iBAAiB;QACjB,kBAAkB,EAAA;MA1I1B;QA8IQ,mBAAmB;QACnB,kBAAkB,EAAA;MA/I1B;QAmJQ,YAAY,EAAA;EAKhB;IAxJJ;MA0JU,UAAU;MACV,kBAAkB;MAClB,SAAS,EAAA;IA5JnB;MAgKU,iBAAiB,EAAA;MAhK3B;QAkKY,cAAc,EAAA,EACf;EAnKX;IA8KI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,2BAA2B,EAAA;IAnL/B;MAsLM,YAAY;MACZ,iBAAiB;MACjB,iBAAiB,EAAA;IAxLvB;MA6LM,uBAAuB,EAAA;IA7L7B;MAkMQ,+BAA+B;MAC/B,cAAc,EAAA;IAnMtB;MAyMQ,+BAA+B;MAC/B,cAAc,EAAA;IA1MtB;MA+MM,mBAAmB;MACnB,gBAAgB;MAChB,aAAa,EAAA;IAjNnB;MAsNM,WAAW;MACX,mBAAmB;MACnB,gBAAgB;MAChB,oBAAoB,EAAA;IAzN1B;MA6NM,mBAAmB;MACnB,gBAAgB;MAChB,WAAW,EAAA;MA/NjB;QAkOQ,mBAAmB;QACnB,iBAAiB;QACjB,YAAY;QACZ,kCAAkC,EAAA;IArO1C;MA0OM,mBAAmB;MACnB,gBAAgB;MAChB,WAAW;MACX,iCAAiC,EAAA;IA7OvC;MAkPM,gBAAgB,EAAA;MAlPtB;QAqPQ,2BAA2B;QAC3B,mBAAmB;QACnB,2BAA2B;QAC3B,qBAAqB,EAAA;IAxP7B;MA6PM,yBAAyB;MACzB,kBAAkB;MAClB,aAAa;MACb,iBAAiB;MACjB,YAAY;MACX,gBAAgB,EAAA;MAlQvB;QAqQQ,aAAa;QACb,uBAAuB;QACvB,mBAAmB,EAAA;QAvQ3B;UAyQU,eAAe;UACf,gBAAgB,EAAA;QA1Q1B;UA8QU,aAAa;UACb,uBAAuB;UACvB,mBAAmB;UACnB,WAAW;UACX,YAAY;UACZ,yBAAyB;UACzB,kBAAkB;UAClB,gBAAgB,EAAA;UArR1B;YAuRY,cAAc;YACd,gBAAgB,EAAA;MAxR5B;;;;QAkSY,iBAAiB,EAAA;MAlS7B;;QAqSY,gBAAgB;QAChB,mBAAmB,EAAA;MAtS/B;QA4SQ,yBAAyB;QACzB,WAAW;QACX,YAAY;QACZ,kBAAkB,EAAA;QA/S1B;UAmTU,cAAc,EAAA;QAnTxB;UAsTU,eAAe,EAAA;QAtTzB;UA0TU,mBAAmB,EAAA;EA1T7B;IAiUI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,gBAAgB,EAAA;IArUpB;MAwUM,iBAAiB,EAAA;MAxUvB;;QA2UQ,iBAAiB,EAAA;MA3UzB;QA8UQ,mBAAmB,EAAA;IA9U3B;MAqVQ,cAAa,EAAA;IArVrB;MA2VM,YAAY;MACZ,mBAAmB,EAAA;EA5VzB;IAiWI,qBAAqB;IACrB,UAAU;IACV,kCAAkC,EAAA;EAnWtC;IAwWM,yBAAyB,EAAA;EAxW/B;IA8WM,yBAAyB,EAAA;EA9W/B;IAoXM,yBAAyB,EAAA;EApX/B;IA0XM,yBAAyB,EAAA;EA1X/B;IAgYM,yBAAyB,EAAA;EAhY/B;IAqYI,kBAAkB,EAAA;EArYtB;IAyYI,yBAAyB;IACzB,kBAAkB,EAAA;EA1YtB;IA+YI,2BAA2B,EAAA;EA/Y/B;IAmZI,kBAAkB;IAClB,iBAAiB,EAAA;EApZrB;IAwZI,aAAa;IACb,8BAA8B,EAAA;EAzZlC;IA6ZI,+BAA+B,EAAA;EA7ZnC;IAiaI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,aAAa;IACb,kBAAkB;IAClB,yBAAyB,EAAA;IAta7B;MAwaM,iBAAiB,EAAA;IAxavB;MA4aM,yBAAyB,EAAA;IA5a/B;MAgbM,cAAc;MACd,iBAAiB,EAAA;IAjbvB;MAqbM,YAAY;MACZ,gCAAgC,EAAA;EAtbtC;IA2bI,kBAAkB;IAClB,YAAY,EAAA;IA5bhB;MA8bM,yBAAyB,EAAA;IA9b/B;MAkcQ,SAAS,EAAA;IAlcjB;MAqcQ,UAAU,EAAA;IArclB;MAwcQ,UAAU,EAAA;IAxclB;MA6cM,6BAA6B;MAC7B,YAAY;MACZ,YAAY,EAAA;IA/clB;MAmdM,aAAa;MACb,uBAAuB;MACvB,mBAAmB;MACnB,YAAY;MACZ,cAAc,EAAA;IAvdpB;MA4dQ,6BAA6B;MAC7B,YAAY;MACZ,YAAY,EAAA;EA9dpB;IAoeI,aAAa;IACb,mBAAmB;IACnB,8BAA8B,EAAA;IAtelC;MAyeM,YAAY;MACZ,iBAAiB;MACjB,6BAA6B;MAC7B,oCAAoC,EAAA;MA5e1C;QA8eQ,cAAc,EAAA;IA9etB;MAmfM,YAAY;MACZ,iBAAiB,EAAA;EApfvB;IAyfI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY,EAAA;EA5fhB;IAggBI,6BAA6B,EAAA;EAhgBjC;IAqgBM,yBAAyB;IACzB,YAAY;IACZ,YAAY,EAAA;EAvgBlB;IA0gBM,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,eAAe,EAAA;IAlhBrB;MAohBQ,gBAAgB;MAChB,iBAAiB,EAAA;EArhBzB;IA0hBM,yBAAyB;IACzB,eAAe;IACf,UAAU;IACV,kBAAkB,EAAA;EA7hBxB;IAkiBI,yBAAyB;IACzB,eAAe;IACf,kBAAkB,EAAA;IApiBtB;MAsiBM,iBAAiB,EAAA;IAtiBvB;MAyiBM,gBAAgB;MAChB,yBAAyB;MACzB,YAAY;MACZ,aAAa;MACb,kBAAkB;MAClB,cAAc,EAAA;IA9iBpB;MAkjBM,YAAY;MACZ,kBAAkB,EAAA;MAnjBxB;QAsjBQ,YAAY;QACZ,yBAAyB,EAAA;QAvjBjC;UA0jBY,yBAAyB,EAAA;IA1jBrC;MAgkBM,aAAa;MACb,mBAAmB;MACnB,YAAY,EAAA;MAlkBlB;QAqkBQ,aAAa;QACb,mBAAmB,EAAA;MAtkB3B;QA0kBQ,kBAAkB,EAAA;EA1kB1B;IAglBI,aAAa;IACb,yBAAyB,EAAA;EAjlB7B;IAqlBI,2BAA2B,EAAA;EArlB/B;IAylBI,WAAW;IACX,eAAe,EAAA;EA1lBnB;IA8lBI,yBAAyB,EAAA;IA9lB7B;MAgmBM,yBAAyB;MACzB,qIAC8D,EAAA;EAlmBpE;IAumBI,YAAY;IACZ,iBAAiB;IACjB,6BAA6B;IAC7B,oCAAoC,EAAA;IA1mBxC;MA4mBM,cAAc,EAAA;EA5mBpB;IAmnBM,4BAA4B;IAC5B,cAAc,EAAA;EApnBpB;IAwnBM,yBAAyB,EAAA;EAxnB/B;IA2nBM,8BAA8B,EAAA;EA3nBpC;IA8nBM,aAAa;IACb,6BAA6B,EAAA;IA/nBnC;MAkoBQ,qBAAqB;MACrB,UAAU;MACV,6CAA+C,EAAA;EApoBvD;IAyoBU,eAAe,EAAA;EAzoBzB;IA4oBI,YAAY;IACZ,iBAAiB;IACjB,6BAA6B;IAC7B,oCAAoC,EAAA;IA/oBxC;MAipBM,cAAc,EAAA;EAjpBpB;IAspBI,yBAAyB;IACzB,YAAY;IACZ,gBAAgB,EAAA;EAxpBpB;IA4pBI,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ,EAAA;EA9pBZ;;IAmqBI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,iBAAiB;IACjB,SAAS;IACT,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,kBAAkB,EAAA;IA7qBtB;;MAgrBM,aAAa;MACb,mBAAmB,EAAA;MAjrBzB;;QAmrBQ,yBAAyB;QACzB,gBAAgB;QAChB,YAAY,EAAA;MArrBpB;;QAwrBQ,gBAAgB;QAChB,iBAAiB,EAAA;IAzrBzB;;MA8rBM,WAAW,EAAA;IA9rBjB;;MAksBM,aAAa;MACb,uBAAuB;MACvB,mBAAmB,EAAA;MApsBzB;;QAssBQ,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,eAAe;QACf,yBAAyB;QACzB,kBAAkB;QAClB,WAAW;QACX,sBAAsB,EAAA;QA7sB9B;;UA+sBU,WAAW;UACX,6BAA6B;UAC7B,YAAY;UACZ,gBAAgB,EAAA;QAltB1B;;UAqtBU,WAAW;UACX,gBAAgB;UAChB,iBAAiB;UACjB,gBAAgB,EAAA;QAxtB1B;;UA2tBU,mBAAmB,EAAA;UA3tB7B;;YA6tBY,iBAAiB,EAAA;QA7tB7B;;UAiuBU,WAAW,EAAA;UAjuBrB;;YAmuBY,iBAAiB,EAAA;QAnuB7B;;UAuuBU,UAAU,EAAA;EAvuBpB;IA8uBI,sBAAsB,EAAA;IA9uB1B;MAgvBM,WAAW,EAAA;MAhvBjB;QAkvBQ,yBAAyB;QACzB,YAAY;QACZ,sBAAsB,EAAA;IApvB9B;MAwvBM,aAAa;MACb,yBAAyB,EAAA;MAzvB/B;QA2vBQ,YAAY;QACZ,iBAAiB;QACjB,6BAA6B;QAC7B,oCAAoC,EAAA;QA9vB5C;UAgwBU,cAAc,EAAA;EAhwBxB;IAuwBI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB,EAAA;IAzwBvB;MA2wBM,YAAY;MACZ,iBAAiB;MACjB,6BAA6B;MAC7B,oCAAoC,EAAA;MA9wB1C;QAgxBQ,cAAc,EAAA;;AAOtB;EACI,YAAY;EACZ,gBAAgB,EAAA;EAFpB;IAIM,YAAY,EAAA;IAJlB;MAOQ,qBAAqB,EAAA;IAP7B;MAWQ,YAAY;MACZ,iBAAiB;MACjB,kBAAkB;MAClB,aAAa;MACb,sBAAsB;MACtB,mBAAmB;MACnB,eAAe;MACf,kBAAkB;MAClB,mBAAmB,EAAA;MAnB3B;QAsBU,eAAe;QACf,eAAe;QACf,kBAAkB,EAAA;MAxB5B;QA4BU,YAAY,EAAA;EA5BtB;IAkCM,SAAS;IACT,sBAAsB;IACtB,yBAAyB,EAAA;IApC/B;MAuCQ,mBAAmB;MACnB,YAAY,EAAA;IAxCpB;MA6CU,+BAA+B;MAC/B,cAAc,EAAA;IA9CxB;MAmDU,kBAAkB,EAAA;IAnD5B;MAuDU,kBAAkB,EAAA;IAvD5B;MA2DQ,kBAAkB,EAAA;IA3D1B;MA+DQ,kBAAkB,EAAA;IA/D1B;MAmEU,WAAW,EAAA;;AAKrB;EACG,oBAAoB;EACrB,qBAAqB;EACrB,4BAA4B,EAAA;;AAG9B;EACE,sBAAsB,EAAA;EADxB;IAGI,eAAe;IACf,mBAAmB;IACnB,iBAAiB,EAAA;EALrB;IAQI,yBAAyB;IACzB,YAAY;IACZ,YAAY,EAAA;;AAIhB;EACE,aAAa;EACb,8BAA8B,EAAA;;AAGhC;EACE,sBAAsB,EAAA;;AAGxB;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB,EAAA;EAHpB;IAKI,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB,EAAA;EATrB;IAYI,iBAAiB;IACjB,cAAc,EAAA;;AAIlB;EACE,UAAU,EAAA;;AAGZ;EACE,yBAAyB;EACzB,kBAAkB,EAAA;;AAGpB;EAIQ,UAAU,EAAA;;AAJlB;EAOQ,UAAU,EAAA;;AAPlB;EAUQ,SAAS,EAAA;;AAVjB;EAaQ,UAAU,EAAA;;AAblB;EAgBQ,SAAS,EAAA;;AAMjB;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW,EAAA;EALb;IAQI,oBAAoB,EAAA;;AAMxB;EACE,aAAa,EAAA;;AAGf;EACE,iBAAiB,EAAA;;AAInB;EACE,iBAAiB;EACjB,WAAW;EACX,oBAAoB;EACpB,mBAAmB,EAAA;;AAGrB;EACE,uBAAsB,EAAA;;AAGxB;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,aAAa;EACb,uBAAuB;EACvB,mBAAmB,EAAA;EARrB;IAUI,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,QAAQ;IACR,kBAAkB,EAAA;IAftB;MAiBM,kBAAkB;MAClB,cAAc;MACd,YAAY,EAAA;MAnBlB;QAqBQ,WAAW;QACX,yBAAyB;QACzB,UAAU,EAAA;QAvBlB;UAyBU,gBAAgB,EAAA;MAzB1B;QA6BQ,WAAW;QACX,0BAA0B;QAC1B,aAAa;QACb,eAAe;QACf,yBAAyB;QACzB,gBAAgB,EAAA;QAlCxB;UAoCU,iBAAiB;UACjB,WAAW,EAAA;MArCrB;QAyCQ,WAAW;QACX,yBAAyB;QACzB,YAAY;QACZ,aAAa;QACb,uBAAuB;QACvB,mBAAmB,EAAA;QA9C3B;UAgDU,eAAe,EAAA;UAhDzB;YAkDY,kBAAkB,EAAA;EAlD9B;IA0DI,QAAQ;IACR,YAAY;IACZ,iBAAiB,EAAA;IA5DrB;MA+DM,kBAAkB,EAAA;IA/DxB;MAoEQ,WAAW,EAAA;IApEnB;MAuEQ,mBAAmB,EAAA;EAvE3B;IA6EI,sBAAsB;IACtB,kBAAkB;IAClB,SAAS,EAAA;EA/Eb;IAmFI,sBAAsB,EAAA;EAnF1B;IAsF8B,sBAAsB,EAAA;;AAGpD;EACE,aAAa,EAAA;EADf;IAGI,WAAW,EAAA;;AAIf;EACE,WAAW;EACX,kBAAkB,EAAA;EAFpB;IAII,kBAAkB;IAClB,WAAW,EAAA;EALf;IASI,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;IAClB,2BAA2B;IAC3B,kBAAkB,EAAA;IAbtB;MAeM,cAAc;MACd,SAAS;MACT,YAAY;MACZ,eAAe,EAAA;EAlBrB;IAuBI,gBAAgB,EAAA;;AAIpB;EAEI,YAAY,EAAA;;AAFhB;EAMI,YAAY,EAAA;;AAIhB;EACE,2CAA2C,EAAA;;AAG7C;EACE,yBAAyB;EACzB,YAAY,EAAA;;AAGd;EAEI,eAAe,EAAA;EAFnB;IAIM,gBAAgB;IAChB,cAAc,EAAA","sourcesContent":["iframe#webpack-dev-server-client-overlay { display: none; }\n\n.outer-dashboard-container {\n  position: relative;\n  border-top: 1px solid #ffffff24;\n  height: calc(100vh - 80px);\n  margin-right: 0px;\n  padding-right: 0px;\n  margin-top: 70px;\n  padding-left: 0px;\n\n  .form-floating > .form-control:focus ~ label, .form-floating > .form-control:not(:placeholder-shown) ~ label, .form-floating > .form-control-plaintext ~ label, .form-floating > .form-select ~ label {\n      color: white;   \n      opacity: 0.65;\n      transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n  }\n\n  .form-floating > .form-control:focus ~ label::after, .form-floating > .form-control:not(:placeholder-shown) ~ label::after, .form-floating > .form-control-plaintext ~ label::after, .form-floating > .form-select ~ label::after {\n      background-color: unset; \n  }\n\n  .sidebar-left {\n    background-color: #011b3a;\n    display: flex;\n    justify-content: flex-start;\n    height: calc(100% - 45px);\n    width: 205px;\n    position: absolute;\n    padding-left: 5px;\n\n    .sidebar-list {\n      list-style: none;\n      color: white;\n      font-size: 16px;\n      font-weight: 500;\n      font-family: Urbanist;\n      margin-top: 3rem;\n      padding-left: 0;\n      white-space: nowrap;\n    }\n\n    .sidebar-item {\n      padding: 8px;\n      padding-left: 1px;\n      padding-right: 1px;\n      padding-top: 11px;\n      padding-bottom: 11px;\n      font-size: 18px;\n    }\n\n    .sidebar-item {\n      &:hover {\n        color: #4fc2d9;\n        cursor: pointer;\n      }\n    }\n\n    .sidebar-item-active {\n      color: #4fc2d9;\n      width: 100%;\n      border-radius: 6px 0 0 6px;\n      background-image: linear-gradient(to right, #4fc2d929, #011b3a);\n    }\n\n    .list-icon {\n      width: 42px;\n    }\n  }\n\n \n  .sidebar-left-sm {\n    width: 110px;\n\n    .sidebar-item {\n      padding: 8px;\n      padding-left: 1px;\n      padding-right: 1px;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      font-size: 12px;\n\n      span {\n        max-width: 80px;\n        text-align: center;\n      }\n\n      svg {\n        height: 30px;\n      }\n    }\n  }\n\n  .insight-navbar-o {\n    background-color: #0a1634;\n  }\n\n  .insight-navbar {    \n    display: flex;\n    align-items: center;\n    color: white;\n    font-weight: bold;\n    height: 57px;\n    justify-content: space-between;   \n    width: 100%;\n    z-index: 9;\n    text-align: center;\n    position: absolute;\n    background-color: #011b3a;\n\n    .navbar-list {\n      display: inline-flex;\n      list-style: none;\n      margin-top: 1rem;\n      padding-left: 10;\n      font-weight: normal;\n      align-items: center;\n     \n      .active {\n        border-bottom: 4px solid #07bc0c;\n        color: #4fc2d9;\n      }\n\n      .navbar-item {\n        padding: 1rem;\n        &:hover {\n          color: #4fc2d9;\n          cursor: pointer;\n        }\n      }\n    }\n\n    .wm-org-title-bar-form {\n      flex-direction: row;\n      display: inline-flex;\n      align-items: center;\n      justify-content: end;\n\n      .wm-organizations-select {\n        margin-left: 10px;\n        margin-right: 20px;\n      }\n\n      .form-label {\n        font-weight: normal;\n        margin-bottom: 0px;\n      }\n\n      textarea {\n        color: white;\n      }\n    }\n  }\n\n    @media only screen and (max-width: 800px) {\n        .wm-org-title-bar {\n          right: 0px;    \n          position: absolute;\n          top: 50px;\n        }\n\n        .insight-navbar .navbar-list{\n          padding-left: 5px;\n          .navbar-item {\n            padding: .5rem;\n          }\n        }\n    }\n\n    @media only screen and (min-width: 801px) {\n\n    }\n\n\n\n  .inner-dashboard-container {\n    position: absolute;\n    top: 80px;\n    left: 230px;\n    color: white;   \n    width: calc(100% - 250px);  \n    height: calc(100vh - 170px);\n\n    h2 {\n      color: white;\n      font-weight: bold;\n      margin-left: 10px;\n    }\n\n\n    .accordion-collapse {\n      color: white !important;\n    }\n\n    .organization-info {\n      .table-container {\n        max-height: calc(100vh - 250px);\n        overflow: auto;\n      }\n    }\n\n    .admin-settings-table {\n      .table-container {\n        max-height: calc(100vh - 280px);\n        overflow: auto;\n      }\n    }\n\n    #organization-dashboard-container {\n      margin-left: -220px;\n      margin-top: 10px;\n      width: 97.5vw;\n    \n    }\n\n    #organization-dashboard-container-bottom {\n      width: 96vw;\n      margin-left: -219px;\n      max-width: unset;\n      padding-bottom: 20px;\n    }\n\n    #referencedata-container {\n      margin-left: -200px;\n      margin-top: 10px;\n      width: 95vw;\n\n      .spinner-overlay {\n        margin-left: -200px;\n        margin-top: 200px;\n        width: 965vw;\n        background: rgba(29, 32, 30, 0.54);\n      }\n    }\n\n    #help-container {\n      margin-left: -200px;\n      margin-top: 20px;\n      width: 95vw;\n      min-width: -webkit-fill-available;\n    }\n\n\n    .table-scroll {\n      margin-top: 10px;\n\n      table {\n        max-height: 90vh !important;\n        overflow: auto auto;\n        height: calc(100vh - 340px);\n        display: inline-block;\n      }\n    }\n\n    .metrics-container {\n      background-color: #0b1736;\n      border-radius: 7px;\n      padding: 1rem;\n      margin-right: 1px;\n      margin: 1rem;\n       min-width: 200px;\n\n      .organization-totals {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        h5 {\n          font-size: 14px;\n          margin-bottom: 0;\n        }\n\n        .number-of-organizations {\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          width: 50px;\n          height: 50px;\n          background-color: #021d3e;\n          border-radius: 8px;\n          margin-left: 4px;\n          h2 {\n            color: #4fc2d9;\n            margin-bottom: 0;\n          }\n        }\n      }\n\n      .metrics-container-top {\n        .metric-headings,\n        .admin-task-top {\n          h5,\n          p {\n            font-weight: bold;\n          }\n          p {\n            margin-top: 1rem;\n            font-weight: normal;\n          }\n        }\n      }\n\n      .metric-container {\n        background-color: #021d3e;\n        margin: 9px;\n        padding: 8px;\n        border-radius: 8px;\n\n\n        .metric {\n          color: #4fc2d9;\n        }\n        .metric-title {\n          font-size: 12px;\n        }\n\n        p {\n          font-weight: normal;\n        }\n      }\n    }\n  }   \n\n  .admin-task-container {\n    background-color: #0b1736;\n    border-radius: 8px;\n    padding: 1rem;\n    margin: 1rem;\n    min-width: 200px;\n\n    .admin-task-top {\n      font-weight: bold;\n      h5,\n      p {\n        font-weight: bold;\n      }\n      p {\n        font-weight: normal;\n      }\n    }\n\n    .admin-task-bottom {\n\n      .table-container{\n        overflow:auto;\n      }\n    }\n\n\n    .admin-task-header {\n      color: white;\n      font-weight: normal;\n    }\n  }\n\n  .form-check-input {\n    border-color: #86b7fe;\n    outline: 0;\n    box-shadow: 0 0 0 0.25rem  #0D6EFD;\n  }\n\n  tr:nth-child(2) {\n    .form-check-input:checked {\n      background-color: #0d6efd;\n    }\n  }\n\n  tr:nth-child(3) {\n    .form-check-input:checked {\n      background-color: #0d6efd;\n    }\n  }\n\n  tr:nth-child(4) {\n    .form-check-input:checked {\n      background-color: #0d6efd;\n    }\n  }\n\n  tr:nth-child(5) {\n    .form-check-input:checked {\n      background-color: #0d6efd;\n    }\n  }\n\n  tr:nth-child(6) {\n    .form-check-input:checked {\n      background-color: #0d6efd;\n    }\n  }\n\n  .header-container {\n    padding-right: 0px;\n  }\n\n  .header-options-container {\n    justify-content: flex-end;\n    padding-right: 0px;\n  }\n\n\n  .dropdown-dashboard {\n    margin-left: 0px !important;\n  }\n\n  .dropdown-more-options-container button{\n    padding-right: 0px;\n    margin-left: 10px;\n  }\n\n  .action {\n    display: flex;\n    justify-content: space-between;\n  }\n  \n  .vertical-seperator {\n    border-right: 2px solid #222d48;\n  }\n\n  .getting-started-container {\n    position: absolute;\n    left: 1%;\n    right: 1%;\n    padding: 1rem;\n    border-radius: 8px;\n    background-color: #0b1736;\n    h5 {\n      font-weight: bold;\n    }\n\n    .accordion-button {\n      background-color: #0b1736;\n    }\n\n    .accordion-button:not(.collapsed) {\n      color: #4fc2d9;\n      font-weight: bold;\n    }\n\n    .accordion-item {\n      border: none;\n      border-bottom: 1px solid #222d48;\n    }\n  }\n\n  table {\n    border-radius: 4px;\n    color: white;\n    td {\n      border: 1px solid #2a2a2a;\n    }\n    thead {\n      th:nth-child(1) {\n        width: 5%;\n      }\n      th:nth-child(2) {\n        width: 20%;\n      }\n      th:nth-child(3) {\n        width: 70%;\n      }\n    }\n\n    input {\n      background-color: transparent;\n      border: none;\n      color: white;\n    }\n\n    .icon-box {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      padding: 10%;\n      color: #4fc2d9;\n    }\n\n    .form-input-wrapper {\n      input {\n        background-color: transparent;\n        border: none;\n        color: white;\n      }\n    }\n  }\n\n  .header-box {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    #export-btn {\n      color: white;\n      font-weight: bold;\n      background-color: transparent;\n      border: 1px solid #4fc2d9 !important;\n      &:hover {\n        color: #4fc2d9;\n      }\n    }\n\n    #addNew-btn {\n      color: white;\n      font-weight: bold;\n    }\n  }\n\n  .action-cell {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n  }\n\n  .reference-data {\n    justify-content: space-around;\n  }\n\n  .org-edit-form {\n    .form-control {\n      background-color: #021d3e;\n      border: none;\n      color: white;\n    }\n    .org-warning-box {\n      display: flex;\n      justify-content: space-around;\n      align-items: center;\n      color: #ff6666;\n      border: 1px solid #ff6666;\n      border-radius: 4px;\n      width: 40%;\n      height: 3rem;\n      font-size: 13px;\n      p {\n        margin-bottom: 0;\n        margin-left: 20px;\n      }\n    }\n\n    .cred-box {\n      background-color: #0b1736;\n      margin-left: 1%;\n      width: 98%;\n      border-radius: 6px;\n    }\n  }\n\n  .user-box {\n    background-color: #0b1736;\n    margin-left: 1%;\n    border-radius: 6px;\n    h4 {\n      padding-top: 1rem;\n    }\n    .user-list {\n      list-style: none;\n      background-color: #021d3e;\n      height: 8rem;\n      padding: 1rem;\n      border-radius: 6px;\n      overflow: auto;\n    }\n\n    .list-group{\n      height: 38vh;\n      overflow-y: scroll;\n\n      .list-group-item {\n        color: white;\n        background-color: #002044;\n\n        &.active{\n            background-color: #4fc2d9;\n        }\n      }\n    }\n\n    .user-list-control-container {\n      display: flex;\n      flex-direction: row;\n      height: 30px;\n\n      .user-list-control-container {\n        display: flex;\n        flex-direction: row;\n      }\n\n      div {\n        margin-right: 10px; \n      }\n    }\n  }\n\n  .footer-button-box {\n    display: flex;\n    justify-content: flex-end;\n  }\n\n  .project {\n    justify-content: flex-start;\n  }\n\n  #footer-btn {\n    width: 9rem;\n    font-size: 14px;\n  }\n\n  .edit-btn {\n    background-color: #4fc2d9;\n    &:hover {\n      background-color: #4da1d8;\n      transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,\n        border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n    }\n  }\n\n  .cancel-btn {\n    color: white;\n    font-weight: bold;\n    background-color: transparent;\n    border: 1px solid #4fc2d9 !important;\n    &:hover {\n      color: #4fc2d9;\n    }\n  }\n\n\n  .monitoring-location-container {\n    .table-container {\n      max-width: calc(100% - 30px);\n      overflow: auto;\n    }\n\n    tbody {\n      background-color: #0b1736;\n    } \n    .table-container {\n      max-height: calc(90vh - 200px);\n    }\n    .action-box {\n      display: flex;\n      justify-content: space-around;\n\n      input {    \n        border-color: #86b7fe;\n        outline: 0;\n        box-shadow: 0 0 0 0.25rem RGB(13 110 253 / 25%);\n      }\n    }\n  }\n  \n  .edit { text-align: end;}\n\n  #export-btn {\n    color: white;\n    font-weight: bold;\n    background-color: transparent;\n    border: 1px solid #4fc2d9 !important;\n    &:hover {\n      color: #4fc2d9;\n    }\n  }\n\n  select, textarea {\n    background-color: #051D3E;\n    border: none;\n    color: #ffffff5c;\n  }\n\n  #filter-box {\n    margin-bottom: 1rem;\n    position: relative;\n    left: 1%;\n  }\n\n  .filter-box,\n  .add-activity-box {\n    display: flex;\n    justify-content: space-between;\n    padding-right: 0px;\n    margin-right: 0px;\n    margin: 0;\n    padding-left: 0;\n    background-color: #0b1736;\n    margin-bottom: 1rem;\n    margin: 0;\n    padding: 1rem;\n    border-radius: 4px;\n\n    .drop-box {\n      display: flex;\n      align-items: center;\n      select {\n        background-color: #021d3e;\n        color: #ffffff82;\n        border: none;\n      }\n      h4 {\n        margin-bottom: 0;\n        margin-right: 4px;\n      }\n    }\n\n    #importII {\n      width: 35vw;\n    }\n\n    .date-range-box {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      .date-box {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        padding: 0.5rem;\n        background-color: #021d3e;\n        border-radius: 8px;\n        margin: 4px;\n        z-index: 11 !important;\n        input {\n          width: 7rem;\n          background-color: transparent;\n          border: none;\n          color: #ffffff82;\n        }\n        p {\n          width: 4rem;\n          margin-bottom: 0;\n          font-weight: bold;\n          color: #ffffff82;\n        }\n        #to {\n          margin-right: -1rem;\n          input {\n            margin-left: -2px;\n          }\n        }\n        #from {\n          width: 5rem;\n          input {\n            margin-left: -5px;\n          }\n        }\n        .react-datepicker-wrapper {\n          width: 70%;\n        }\n      }\n    }\n  }\n\n  .add-activity-box {\n    width: 100% !important;\n    form {\n      width: 100%;\n      input[type=\"text\"] {\n        background-color: #021d3e;\n        border: none;\n        color: #fff !important;\n      }\n    }\n    .add-activities-button-box {\n      display: flex;\n      justify-content: flex-end;\n      #export-btn {\n        color: white;\n        font-weight: bold;\n        background-color: transparent;\n        border: 1px solid #4fc2d9 !important;\n        &:hover {\n          color: #4fc2d9;\n        }\n      }\n    }\n  }\n\n  .results-wrapper {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    #export-btn {\n      color: white;\n      font-weight: bold;\n      background-color: transparent;\n      border: 1px solid #4fc2d9 !important;\n      &:hover {\n        color: #4fc2d9;\n      }\n    }\n  }\n}\n\n\n.outer-dashboard-container-sm {\n    width: 100vw;\n    margin-top: 70px;\n    .sidebar-left {\n      width: 110px;\n\n      .sidebar-list {\n        white-space: pre-wrap;\n      }\n\n      .sidebar-item {\n        padding: 8px;\n        padding-left: 1px;\n        padding-right: 1px;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        font-size: 12px;\n        text-align: center;\n        margin-bottom: 15px;\n\n        span {\n          max-width: 80px;\n          margin-top: 2px;\n          text-align: center;\n        }\n\n        svg {\n          height: 30px;\n        }\n      }\n    }\n\n    .inner-dashboard-container {\n      top: 80px;\n      left: 120px !important;  \n      width: calc(100% - 110px);\n\n      .fullscreen-watermonitoringreport {\n        margin-left: -110px;\n        width: 100vw;\n      }\n\n      .organization-info {\n        .table-container {\n          max-height: calc(100vh - 250px);\n          overflow: auto;\n        }\n      }\n\n      #organization-dashboard-container {\n          margin-left: -90px;\n      }\n\n      #organization-dashboard-container-bottom {\n          margin-left: -90px;\n      }\n\n      #referencedata-container {\n        margin-left: -90px;\n      }\n\n      #help-container {\n        margin-left: -80px;\n      }\n\n      .admin-container {\n          width: 90vw;\n      }\n    }\n}\n\n.wm-table-overflow {\n   display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;  \n}\n\n.bulk-import {\n  flex-direction: column;\n  h3 {\n    font-size: 18px;\n    margin-bottom: -8px;\n    font-weight: bold;\n  }\n  textarea {\n    background-color: #041b3c;\n    border: none;\n    color: white;\n  }\n}\n\n.bottom-half {\n  display: flex;\n  justify-content: space-between;\n}\n\n.import-details {\n  flex-direction: column;\n}\n\n.danger-box {\n  border: 1px solid #ff6666;\n  padding: 4px;\n  border-radius: 4px;\n  .warning-icon {\n    border: 2px solid #ff6666;\n    border-radius: 50%;\n    padding-right: 8px;\n    padding-left: 7px;\n    font-weight: bold;\n  }\n  span {\n    margin-left: 12px;\n    color: #ff6666;\n  }\n}\n\n.edit-roll {\n  width: 96%;\n}\n\n.active-input {\n  background-color: #021d3e;\n  border-radius: 4px;\n}\n\n.reference-data-table-container {\n  table {\n    thead {\n      th:nth-child(1) {\n        width: 20%;\n      }\n      th:nth-child(2) {\n        width: 50%;\n      }\n      th:nth-child(3) {\n        width: 5%;\n      }\n      th:nth-child(4) {\n        width: 20%;\n      }\n      th:nth-child(5) {\n        width: 5%;\n      }\n    }\n  }\n}\n\n.wm-org-cred {\n  flex-direction: row;\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  width: auto;\n\n  button {\n    align-self: flex-end;\n  }\n}\n\n\n\n.wm-org-display-none {\n  display: none;\n}\n\n.wm-indent {\n  padding: 2px 12px;\n}\n\n\n.wm-org-cred-check {\n  margin-left: 14px;\n  width: 30px;\n  display: inline-flex;\n  vertical-align: top;\n}\n\n.wm-reference-select {\n  color:white !important;\n}\n\n.modal-container {\n  position: absolute;\n  z-index: 500;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.486);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  .modal-wrapper {\n    width: 40%;\n    height: 30%;\n    background-color: #0a1634;\n    position: absolute;\n    top: 20%;\n    border-radius: 4px;\n    .modal {\n      position: absolute;\n      display: block;\n      color: white;\n      .modal-header {\n        width: 100%;\n        background-color: #0a1634;\n        height: 5%;\n        p {\n          margin-bottom: 0;\n        }\n      }\n      .modal-body {\n        width: 100%;\n        height: calc(100% - 100px);\n        display: flex;\n        flex-wrap: wrap;\n        align-content: flex-start;\n        overflow-y: auto;\n        .form-check {\n          margin-right: 6px;\n          width: 100%;\n        }\n      }\n      .modal-footer {\n        width: 100%;\n        background-color: #0a1634;\n        height: 30px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        .modal-button-container {\n          margin-top: 5px;\n          button {\n            margin-right: 14px;\n          }\n        }\n      }\n    }\n  }\n\n  .add-char-wrapper {\n    top: 5vh;\n    height: 80vh;\n    max-height: 700px;\n\n    .col-4 {\n      align-self: center;\n    }\n\n    .col-8 {\n      input {\n        margin: 4px;\n      }\n      .label {\n        vertical-align: sub;\n      }\n    }\n  }\n\n  .add-char-modal-footer {\n    height: 10% !important;\n    position: absolute;\n    bottom: 0;\n  }\n\n  .translation-modal-wrapper {\n    height: 25% !important;\n  }\n\n  .translation-modal-footer { height: 20% !important; }\n}\n\n.double-btn-box {\n  display: flex;\n  button {\n    margin: 4px;\n  }  \n}\n\n.gir-container {\n  width: 80vw;\n  position: relative;\n  .gir-tabs-container {\n    position: absolute;\n    width: 100%;\n  }\n\n  .info-box {\n    border: 1px dashed #3e982e;\n    text-align: center;\n    border-radius: 4px;\n    background-color: #3e982e3d;\n    position: relative;\n    p {\n      color: #3e982e;\n      margin: 0;\n      padding: 4px;\n      font-size: 14px;\n    }\n  }\n\n  .characteristic {\n    text-align: left;\n  }\n}\n\n.add-activity-box {\n  select {\n    color: white;\n  }\n\n  textarea {\n    color: white;  \n  }\n}\n\n.wm-popover {\n  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.2);\n}\n\n.wm-popover-header {\n  background-color: #12234f;\n  color: white;\n}\n\n.wqx-container-modal {\n  .modal-dialog {\n    max-width: 70vw;\n    .modal-body{\n      max-height: 70vh;\n      overflow: auto;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
